export default __webpack_public_path__ + "static/media/bg-explore.3c87fad9.mp4";